import axios from "axios";
import { TFunction } from "react-i18next";
import { toast } from "react-toastify";
import { ApiResponse } from "../models/ApiResponse";
import { PasswordResetRequiredError } from "../models/PasswordResetRequiredError";
import { authLoginURL, baseURL } from "../constants/urls";
import { decodeBase64, getParamfromUrl, DecodedData } from "../utils/shared";

export const AuthorizeCallback = async (username: string, password: string, t: TFunction): Promise<boolean> => {
  const params = new URLSearchParams(window.location.search);
  const callback = params.get("callback");

  if (callback !== null) {
    if (!callback.startsWith(authLoginURL)) {
      toast.error(t("unknownAuthenticationServer") as string);
      return false;
    }

    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const result = await axios.post<ApiResponse<any>>(
        callback,
        new URLSearchParams({
          username: username,
          password: password,
        }),
      );
      if (result.data.statusCode === 200) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        window.location.href = result.data.data;
        return true;
      } else if (result.data.status === "Forbidden") {
        toast.error(t("invalidUserNameOrPassword") as string);
        return false;
      } else {
        toast.error(result.data.status);

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,
        if (result.data.data?.command === "PasswordReset") {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument
          throw new PasswordResetRequiredError(result.data.data.passwordResetToken);
        }

        return false;
      }
    } catch (error) {
      if (error instanceof PasswordResetRequiredError) {
        throw error;
      }

      toast.error(axios.isAxiosError(error) ? error.message : (error as string));
      return false;
    }
  } else {
    toast.error(t("noCallbackProvided") as string);
    return false;
  }
};

export const SSOLogin = async (url: string, key: string, t: TFunction) => {
  const stateValue = getParamfromUrl(url, key);
  if (stateValue) {
    try {
      const parsedData: DecodedData = decodeBase64(stateValue);
      const response = await axios.get(`${baseURL}sso/login`, {
        params: {
          redirect_uri: parsedData.redirectUri,
          Scope: parsedData.scope,
          State: parsedData.state,
        },
      });
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const data: string = (await response.data.data) as string;
      if (data) {
        window.location.href = data;
      } else {
        toast.error(t("invalidUrlForRedirection") as string);
      }
    } catch (error) {
      toast.error(t("errorToRedirectSSO") as string);
    }
  } else {
    toast.error(t("noStateParameter") as string);
  }
};
